import { render, staticRenderFns } from "./TableDropdown.vue?vue&type=template&id=08dd0c52&"
import script from "./TableDropdown.vue?vue&type=script&lang=js&"
export * from "./TableDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TableDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports